import {useItem, useOnScreen} from '@adamlip/okeoke.client'
import {Skeleton} from '@heroui/react'
import {useRef, useState} from 'react'
import 'react-swipeable-list/dist/styles.css'
import ItemData from 'views/_Order/Order/Items/ItemCard/ItemData'

function OrderItemCard({bannedItems, itemUUID, forceHideDesc, selectedSizeUUID, banned, readOnly, menuItemParams, isLoading, valid, disabled}) {
	const [itemModalOpen, setItemModalOpen] = useState(false)
	const rootMargin = '100px'
	const ref = useRef(null)
	const onScreen = useOnScreen(ref, rootMargin)
	const {assembledItem, setCount} = useItem(itemUUID, selectedSizeUUID)

	if (assembledItem?.visibleSizes < 1) {
		return null
	}

	return (
		<div ref={ref} className='min-h-[100px] max-h-[140px] w-full px-2'>
			{((menuItemParams?.onScreenOff == null && !onScreen) || isLoading || assembledItem == null) && (
				<>
					<Skeleton className='rounded-lg bg-orderItemCardBackground w-full h-[110px]'></Skeleton>
				</>
			)}
			{((menuItemParams?.onScreenOff == null && onScreen) || menuItemParams?.onScreenOff) && assembledItem != null && assembledItem?.visibleSizes !== 0 && (
				<ItemData banned={banned} forceHideDesc={forceHideDesc} itemUUID={itemUUID} menuItemParams={menuItemParams} selectedSizeUUID={selectedSizeUUID} readOnly={readOnly} />
			)}
		</div>
	)
}

export default OrderItemCard
